import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const helpLine = Loadable(() => import('../../containers/web/helpLine'));
export default MapTo('vcg/components/soe-home/react/helpLine')(helpLine);
